// Club-side role + radar-access detection for the Club Radar (P3/P4).
//
// There is no shared isClub helper in the codebase — the header nav inlines
// `ClubAdmin || Staff || Coach` (useHeaderNavigation.js:33) and the inbox uses
// its own laneContribution. This is the ONE place the Club Radar decides
// "is this a club user, and may they use the radar?", so every entry point
// (page gate, profile-header button, nav) reads the same rule.
//
// Club roles: ClubAdmin, Coach, and Staff (staff working for a club). The nav
// already treats all Staff as club-capable; the real backoffice exclusion is the
// access_radar permission (R9), not a role split — so we keep the role test broad
// and let the permission gate do the filtering.
import { ROLES } from "../config/roles";

export const CLUB_RADAR_ROLES = [ROLES.ClubAdmin, ROLES.Coach, ROLES.Staff];

// A user is on the club side when their active role is a club role.
export const isClubRadarRole = (role) => CLUB_RADAR_ROLES.includes(role);

// access_radar — the new ClubRole permission (R9). Default ON for football roles,
// OFF for pure backoffice roles; managed via the existing role management.
// ClubAdmin always has it (R6/R9 fallback). Permissions come from
// state.auth.permissions (mirrored onto state.auth.user.permissions).
export const RADAR_PERMISSION = "access_radar";

export const hasRadarAccess = (role, permissions) =>
  role === ROLES.ClubAdmin ||
  (Array.isArray(permissions) && permissions.includes(RADAR_PERMISSION));

// Full gate for the Club Radar surface: a club user WITH radar access.
export const canUseClubRadar = (role, permissions) =>
  isClubRadarRole(role) && hasRadarAccess(role, permissions);
